import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'next-i18next';

import { OverviewSection } from '@phoenix/team-m/dashboard/frontend/ui/overview/overview-section';

import { YoutubeVideos } from './youtube-videos';
import { TimberSportsEvents } from './timbersports-events';
import { NewsAndUpdates } from './news-and-updates';

export const InterestingForYouSection: FC<PropsWithChildren> = () => {
  const { t } = useTranslation();

  return (
    <OverviewSection headline={t('dashboard_interestingForYou_headline')} dataTestId="interesting-for-you">
      <NewsAndUpdates />
      <YoutubeVideos />
      <TimberSportsEvents />
    </OverviewSection>
  );
};
